// Defining consts separate to real functionality keeps bundle sizes down
/**
 * A little something to let the content breathe
 */
export const DOC_EXTRA_HORIZONTAL_MARGIN = 30;
/**
 * Margin around ssr doc pages. Not set in CSS since we need to use it for calculations.
 */
export const DOC_LI_MARGIN = 16;
// Padding amounts are total left+right or top+bottom
export const IMAGE_PADDING = {
    vertical: 40,
    horizontal: 72,
};
//# sourceMappingURL=sizing_const.preenvesnextjs.map
